/* tslint:disable:max-line-length */
import {Injectable, OnDestroy} from '@angular/core';
import {ActivityDataLoaderService} from '@docma-mm-core/activity/activity-data-loader.service';
import {AttachmentDataLoaderService} from '@docma-mm-core/attachment/attachment-data-loader.service';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {Fault} from './fault';
import {FaultData} from './fault-data';

@Injectable()
export class FaultDataLoaderService implements OnDestroy {


  constructor(private readonly attachmentLoaderService: AttachmentDataLoaderService,
              private readonly activityLoaderServce: ActivityDataLoaderService) {

  }


  ngOnDestroy(): void {
  }


  public deepLoadFromData(fault: Fault, fullFaultData: FaultData, mergeExisting: boolean = false): Fault {

    const loadDate = new Date(Date.now());
    const faultData = {... fullFaultData};
    delete faultData.Files;
    delete faultData.Activities;
    fault.loadState = new LoadState({status: LoadStatusEnum.Loaded, date: loadDate, data: faultData});
    const attachments = fault.attachments ?? [];
    fault.attachments = [];
    this.attachmentLoaderService.mergeWithLoadData(attachments, (fullFaultData?.Files ?? []), loadDate, mergeExisting).forEach(a => {
      fault.addAttachment(a.attachment);
      // fault.addScribbles(a.scribbles);
    });

    const activities = fault.activities ?? [];
    fault.activities = [];
    fault.addActivities(this.activityLoaderServce.mergeWithLoadData(fault, (activities ?? []), (fullFaultData?.Activities ?? []), loadDate, mergeExisting));

    return fault;
  }

}
